import React,{ useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import Table from "../../components/admin/Table";
import { getList, resetApiStatus } from "../../slices/OrdersSlice";
import { useDispatch, useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { GoogleMap } from "../shoppingPartners/google-map";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { CamelToSentanceCase, ToSelectOption } from "../../Utils/utils/CommanFnc";
import { Controller, useForm } from "react-hook-form";
import { AsyncPaginate } from 'react-select-async-paginate';
import { getList as getProductList } from "../../slices/ProductsSlice";
import SelectBox from "../../components/admin/SelectBox";
import { getAllState, getSubCategoriesList } from "../../slices/InitialDataSlice";

export function List() {
  
  const [requestInProgress, setRequestInProgress] = useState(false);
  
  const [todayDate, setTodayDate] = useState(new Date()) 
  
  const [pageName, setPageName] = useState('');
  
  const [businessData, setBusinessData] = useState([]);
  
  const [columsData, setColumsData] = useState([]);
  
  const data = useSelector((state) => state.orders)
  
  const loading = useSelector( (state) => state.orders.loading )
  
  const [searchParams, setSearchParams] = useSearchParams()
  
  const dispatch = useDispatch() 
  
  const params =  useParams() 
  
  const [isMapOpen, setIsMapOpen] = useState(false)
  
  const [latLng, setLatLng] = useState('');
  
  const [pageTitle, setPageTitle] = useState('')
  
  const queryString = Object.fromEntries([...searchParams.entries()])
  
  const [cateList, setCateList] = useState([]);
  
  const {
      subCategories:categories, 
      //StateList,
      //CitiesList
  } = useSelector((state) => state.initialData);
  
  //const [states, setStates] = useState([])

  const [serachString, setSearchString] = useState({
    date: queryString.date? queryString.date : todayDate,
    endDate: queryString.endDate? queryString.endDate : todayDate
  })
  
  const [defaultParams, setDefaultParams] = useState({
    pageLength:defaultConfig.defaultLimit,
    date: moment(queryString.date).format('YYYY-MM-DD'),
    endDate: moment(queryString.endDate).format('YYYY-MM-DD'),
    page:1
  });
  
  const location = useLocation();
  
  const {
    handleSubmit,
    control,    
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    //resolver: yupResolver(formSchema),
  });

  useEffect( () => {
    const page = location.pathname.split('/').findLast( (item) =>  item );
    setPageName(page)
    setTodayDate(new Date())
  },[location])

  const openMap = useCallback((params = {}) => {
    if(isMapOpen){
      setIsMapOpen(false)
    }else{
      setLatLng(params?.punchInLatLong)
      setIsMapOpen(true)
    }
  },[isMapOpen])

  const columns = useMemo(()=>{
    let col = [
      {
        
        name:"Products Count",
        sortable: true,
        center: true,
        cell: (row) => {
          const productNames = row.product?.map(element => {
              return element?.name
          });
         return <> <Link href="#" data-tooltip-id="my-tooltip" data-tooltip-content={productNames.join(', ')}>{`Count ${row.product.length}`}</Link> </> 
        }
        //selector: (row) => row.product.length ,
      },
      {
        
        name:"Order To",
        sortable: true,
        center: true,
        selector: (row) =>  row.orderTo?.shopName ,
      },
      {
        
        name:"Agent",
        sortable: true,
        center: true,
        selector: (row) => row.userDetail?.name,
      },
      {
        name:"Total Amount",
        selector:(row) => row.totalAmount,
        sortable:true,
        center:true
      },
      {
        name:"Final Amount",
        selector:(row) => row.finalAmount,
        sortable:true,
        center:true
      },
      {
        name:"Status",
        selector:(row) => CamelToSentanceCase(row.status),
        sortable:true,
        center:true
      },
      {
        name: "Action",
        width:"7%",
        button: false,
        center: true,
        cell: (row) => (
          <> 
           <Link to={{
            pathname: `/orders/view/${row._id}`,
            search: "",
            hash: ""}}  
            replace={true}
            state={{ pageName: pageName, page: defaultParams.page, pageLength: defaultParams.pageLength } } className="sidebar-link" data-toggle="tab">
            {" "}
            <i className="fa fa-eye"></i>{" "}
          </Link> 
          </>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
      }
    ];
    
    const fromCol = {
      name:"Order From",
      selector: (row) => row.orderFrom.shopName,
      sortable: true,
      center: true,
    }

    if (pageName === 'my-received-orders') {
      col.splice(1, 1, fromCol) 
    } else if( pageName === "orders" ) {
      col.splice(1, 0, fromCol)
    }

    return col
  },[defaultParams.page, defaultParams.pageLength, pageName])   
  
//   useEffect( () => {
//     const list = [];
//     StateList?.forEach(item => {
//       if(item._id !== ""){
//         list.push({
//           value : item._id,
//           label: CamelToSentanceCase(item.name)
//         })
//       }
//     })
//     setStates(list)
// }, [StateList])

  useEffect(() => {
    dispatch(getSubCategoriesList({catId: ''}))
    dispatch(getAllState())
  },[dispatch])


  useEffect(()=>{
    if(Object.keys(queryString).length === 0){
      dispatch(getList({data:{...defaultParams, pageName}}))
    }else{
      setDefaultParams({...defaultParams, ...queryString}) 
    }
   
    if(pageName === 'received-orders') {
        setPageTitle('Received Orders');
    } else {
      setPageTitle('All Orders');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch, pageName]);

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])

  useEffect( ()=>{
    setBusinessData(data)
    setCateList(ToSelectOption(categories, {value:'_id', label: 'name'}))
  },[data, categories])

  useEffect( ()=>{ 
    dispatch(resetApiStatus())
  }, [])

  const setValue = (value, name) => {
    setSearchString({...serachString, [name]: value})
  }

  const searchInt = async (data) => { 
    let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
    setSearchParams(params)  
    setDefaultParams(params)
    params.date = moment(data.date).format('YYYY-MM-DD')
    params.endDate = moment(data.endDate).format('YYYY-MM-DD')
    dispatch(getList({data:{...params, pageName}}))
  }

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
    setSearchParams(params)  
    setDefaultParams(params)
  }

  const resetSearch = () =>{
    const date = moment(todayDate).format('YYYY-MM-DD')
    const endDate = moment(todayDate).format('YYYY-MM-DD')
    const queryPrm = {pageLength: defaultConfig.defaultLimit, page:1, date, endDate}
    setDefaultParams(queryPrm)
    setSearchParams(queryPrm)
    setSearchString({ date, endDate }) 
    dispatch(getList({data:{...queryPrm, pageName}}))
  }

  // const onStateChange = (callback, opt) => {
  //   setValue('cityId', '')
  //   setValue('pincodeId', '')
  //   setValue('beatId', '')
  //   if(opt?.value){
  //     dispatch(CityByState(opt?.value || ''))
  //   }
  //   callback(opt?.value || '')
  // }

  // useEffect( () => {
  //   const cityList = [];
  //   CitiesList?.forEach(item => {
  //     if(item._id !== ""){
  //       cityList.push({
  //         value : item._id,
  //         label: CamelToSentanceCase(item.name)
  //       })
  //     }
  //   });
  //   setCities(cityList)
  // }, [CitiesList])

  // const onCityChange = (callback, opt) => {
  //   const stateAreaList = CitiesList?.find( (item) => item._id ===  opt?.value )
  //   const pincodeList = stateAreaList?.areas?.map( (item) => {
  //     return {
  //       value : item._id,
  //       label: item.pincode
  //     }
  //   })
  //   setAreaList(stateAreaList?.areas || [])
  //   setPincodes(pincodeList || [])
  //   callback(opt?.value || '')
  // }

  // const onPincodeChange = (callBack, opt) => {
  //   const beatsList = areaList?.filter( (item) => item.pincode ===  (opt?.label || ''))
  //     setBeats(() => {
  //       return ToSelectOption(beatsList, {value: "_id", label: "name"}) 
  //     })
  //     callBack(opt?.value || '')   
  // }

  async function loadProducts( search, loadedOptions, { page } ) {
    if(!requestInProgress){
        setRequestInProgress(true)
        const {meta, payload} = await dispatch(getProductList({data : {pageLength:defaultConfig.defaultLimit, page: page, searchString: search}}))
        let productList = []
        if(meta.requestStatus === "fulfilled"){
            setRequestInProgress(false)
            productList = payload?.docs.map(({_id: productIds, name, price}) => { return { label:`${name})` , value : productIds, price } })
        }
        
        return {
            options: productList,
            hasMore: productList?.length > 0? true : false,
            additional: {
                page: page + 1
            }
        };

    }else  {
        return {
            options:[],
            hasMore:true,
            additional: {
                page: page
            }
        };
    }
  }
  return (
    <React.Fragment>
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> { pageTitle } </h4>
              </div>
              <div className="row m-3">
                  <div className="col-sm-10 pl-0">
                    <form onSubmit={handleSubmit(searchInt)}>
                      <div className="row ml-2">
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}} className="text-left">Start Date</label>
                            <Controller
                                control={control}
                                name="startDate"
                                render={({ field: { value, onChange } }) => (
                                  <DatePicker 
                                    width="100%"
                                    showMonthDropdown 
                                    showYearDropdown 
                                    className="form-control" 
                                    selected={new Date(serachString.date)} 
                                    maxDate={todayDate}
                                    onChange={(date) => setValue(date, 'date')}
                                  />  
                                  )
                                }
                            />
                                
                          </div>  
                          <div className="mr-1">
                            <label style={{'justifyContent':'left'}}>End Date</label>
                            <Controller
                                  control={control}
                                  name="endDate"
                                  render={({ field: { value, onChange } }) => (
                                    <DatePicker
                                      selected={new Date(serachString.endDate)}
                                      className="form-control"
                                      onChange={(date) => setValue(date, 'endDate')}
                                      minDate={new Date(serachString.date)}
                                      showMonthDropdown
                                      showYearDropdown
                                      maxDate={todayDate}
                                    />
                                  )
                                }
                            />
                          </div>
                          <div className="col-sm-3 mb-3 p-0">
                              <label style={{'justifyContent':'left'}}>Categories</label>
                              <Controller
                                  control={control}
                                  name="categoryId"
                                  //value={defaultConfig.status[0]["value"]}
                                  //defaultValue={defaultConfig.status[0]["value"]}
                                  render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                      options={cateList}
                                      isClearable={true}
                                      onChange={(opt) => onChange(opt?.value)}
                                      value={cateList.find(
                                        (option) => option.value === value
                                      )}
                                    />
                                  )}
                                />
                          </div>
                          &nbsp;
                          <div className="col-sm-3 p-0">
                              <label style={{'justifyContent':'left'}}>Product</label>
                              <Controller
                                  control={control}
                                  name={`productId`}
                                  render={({ field: { value, onChange } }) => (
                                      <AsyncPaginate
                                          //value={selectedProduct}
                                          loadOptions={loadProducts}
                                          onChange={ (e)=>onChange(e.value) }
                                          additional={{
                                              page: 1,
                                          }}
                                      />
                                  )}
                              />                     
                          </div>
                          &nbsp;
                      
                        {/* <div className="col-sm-2 p-0">
                          <label style={{'justifyContent':'left'}}>State</label>
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="stateId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={states}
                                  isClearable={true}
                                  placeholder="Select State"
                                  onChange={(opt) => onStateChange(onChange, opt)}
                                  value={states.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-2 p-0">
                          <label style={{'justifyContent':'left'}}>City</label>
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="cityId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={cities}
                                  placeholder="Select City"
                                  isClearable={true}
                                  onChange={(opt) => onCityChange(onChange, opt)}
                                  value={cities.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-2 p-0">
                          <label style={{'justifyContent':'left'}}>Pincode</label>
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="pincodeId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={pincodes}
                                  placeholder="Select Pincode"
                                  isClearable={true}
                                  onChange={(opt) => onPincodeChange(onChange, opt)}
                                  value={pincodes?.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-2 p-0">
                        <label style={{'justifyContent':'left'}}>Beat</label>
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="beatId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={beats}
                                  placeholder="Select Beats"
                                  isClearable={true}
                                  onChange={(opt) => onChange(opt?.value || '')}
                                  value={beats.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div> */}
                        <div className="mt-5">
                          <label>&nbsp;</label>
                          <button type="submit" className="btn btn-primary btn-lg">
                            <i className="fa fa-search"></i>
                          </button>
                          &nbsp;
                          <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                            <i className="fas fa-undo"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                    
                  </div>
                  <div className="col-sm-2 text-right">
                    <Link
                      to={"/orders/create"}
                      className="button blue-button btn-success mt-5"
                      data-toggle="tab"
                    >
                      <i className="fas fa-tag"></i>
                      {" "}
                      Place Order{" "}
                    </Link>
                  </div>
              </div>
              <Table 
                totalCount={businessData.totalCount}
                type={params.type}
                data={businessData.list} 
                columns={columsData} 
                dataLoadFnc={getList} 
                extraConfig = {{...defaultParams, pageName}}
                loading={loading}  
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
        {isMapOpen?<GoogleMap setLocationData={()=>{}} data={ {latLng, readOnly:true} } openMap={openMap} />:''}
      </div>
    </React.Fragment>
  );
}
